import { render, staticRenderFns } from "./radioGroupConfig.vue?vue&type=template&id=89878860"
import script from "./radioGroupConfig.vue?vue&type=script&lang=js"
export * from "./radioGroupConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports